export const typesMapping = {
  colors: 'color',
  fonts: 'font',
  icons: 'icon',
  images: 'image',
  logos: 'logo',
  texts: 'text',
  videos: 'video'
};
